import styled from 'styled-components';

export const Container = styled.div`
  text-align: center;
  padding: 1rem 5rem;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 1rem;
  border: 2px solid #6b6b6b6b;
  margin-bottom: 1rem;
  div {
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
    img {
      height: 2.5rem;
      margin-right: 1rem;
    }
    h2 {
      font-size: 22px;
      font-weight: 300;
    }
  }
  h1 {
    font-size: 38px;
    font-family: Roboto, sans-serif;
    font-weight: 900;
    color: #000000;
  }
  @media (min-width: 2000px) {
    width: 100%;
  }
  @media (max-width: 1366px) {
    padding: 1rem 3rem;
    div {
      h2 {
        font-size: 14px;
        font-weight: 300;
      }
    }
    h1 {
      font-size: 22px;
      font-family: Roboto, sans-serif;
      font-weight: 900;
      color: #000000;
    }
  }
  @media (max-width: 1025px) {
    padding: 1rem;
    div {
      h2 {
        font-size: 12px;
        font-weight: 300;
      }
    }
    h1 {
      font-size: 20px;
    }
  }
  @media (max-width: 769px) {
    padding: 0.5rem;
    div {
      h2 {
        font-size: 12px;
        font-weight: 300;
      }
    }
    h1 {
      font-size: 16px;
    }
  }
  @media (max-width: 601px) {
    padding: 0.5rem;
    div {
      img {
        height: 1.5rem;
        margin-right: 0.5rem;
      }
      h2 {
        font-size: 10px;
        font-weight: 300;
      }
    }
    h1 {
      font-size: 16px;
    }
  }
  @media (max-width: 415px) {
    border-radius: 0.5rem;
    padding: 0.5rem;
  }
`;
